/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Service} from "../models/service";
import {ServiceService} from "../services/service.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ServicesResolver implements Resolve<Service[]> {

  constructor(
    private mServiceService: ServiceService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Service[]> {
    try {
      return await this.mServiceService.getAllServices();
    } catch (error) {
      console.error("Problem resolving Services... Error: " + error, error);
    }
  }

}
